export default __webpack_public_path__ + "static/media/7.11c86410.png";